<template>
    <v-dialog v-model="dialog" width="auto">
        <div class="mt-4">
            <v-alert
            title="Внимание!"
            type="info"
            color="purple-lighten-2"
            density="compact"
        
            
            text="Для работы сайта и его взаимодействия с пользователями мы используем файлы cookie и локальное хранилище браузера. 
            Продолжая работу с сайтом, Вы разрешаете использование cookie-файлов и локального хранилища браузера. 
            Вы всегда можете отключить файлы cookie в настройках Вашего браузера."   >
                <v-row>
                    <v-spacer></v-spacer>
                    <v-col></v-col>
                    <v-btn @click="acceptCookies" variant="outlined" class="ma-4">Принять</v-btn>
                </v-row>
            </v-alert>
        </div>
    </v-dialog>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";


  export default {
    name: "CookieBanner",

    setup() {
    const dialog = ref(false);
   
    function acceptCookies() {
        dialog.value = false;
        localStorage.setItem("acceptCookies",true);
      }
      onMounted(() => {
        if(localStorage.getItem("acceptCookies")){
            console.log("c: " + localStorage.getItem("acceptCookies"))
            if (localStorage.getItem("acceptCookies")=="true"){
                dialog.value = false;
            } else {
                dialog.value = true; 
            }
        } else {
            dialog.value = true;
        }
    });
      return {dialog,
        acceptCookies
      }
    },



  }
  
  </script>
  
  <style lang="scss">
 
  </style>